import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {AbstractControl, FormControl, Validators} from "@angular/forms";

@Component({
	templateUrl: './renew_trial.component.html'
})
export class RenewTrialModalComponent extends BaseSupportModalComponent {
	siteId: string;
	trialExpiration: number;
	rtfsFilter: string = 'addDays';
	addDays: number = 1;
	dateTrialStart: string = '2000-01-01';

	ngOnInit() {
		this.spreader.base.form = this.form;

		this.form.addControl('dateTrialStart', new FormControl('', [
			this.getStandartValidator('dateTrialStart_format', this.CustomValidators.dateFormat('YYYY-MM-DD'), '"Новая дата начала триала" - Неверный(YYYY-MM-DD) формат даты'),
			this.getStandartValidator('dateTrialStart_min', this.CustomValidators.dateNotBeforeToday('YYYY-MM-DD'), '"Новая дата начала триала" - Дата не может быть меньше текущей'),
		]));

		this.form.addControl('addDays', new FormControl('', [
			this.getStandartValidator('addDays_maxValue', Validators.max(100 * 365), 'Тариф нельзя продлить больше чем на 100 лет'),
		]));
	}

	async ok() {
		await this.supportService.renewTrial(this.siteId, this.addDays, this.rtfsFilter, this.dateTrialStart, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
